import { render } from "./SenaraiNotis8A.vue?vue&type=template&id=49b7be42"
import script from "./SenaraiNotis8A.vue?vue&type=script&lang=js"
export * from "./SenaraiNotis8A.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__